import { IToolBOMListResponseVM } from '../../models/response/IToolBOMResponse';

export const getToolBOMListInitialState: IToolBOMListResponseVM = {
  ToolBOM: [],
  PagingDetails: {
    CurrentPage: 1,
    PageSize: 100,
    TotalPages: 0,
    TotalRecords: 0,
  },
};

export default getToolBOMListInitialState;
